export default __webpack_public_path__ + "static/media/348.4ea256ba.png";